import React from 'react';

export const ChevronRight = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1 1.5L7 7.5L1 13.5'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default ChevronRight;
